var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expired-shared-page"},[_c('riseup-header'),_vm._v(" "),_c('div',{staticClass:"hourglass"},[_vm._v("⌛️")]),_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v("פג תוקף העמוד שהגעת אליו")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }